import { Toaster } from "react-hot-toast";
import TableComponent from "./components/Table";
import { ModalMessageApprovalHours } from "./components/ModalMessage/modalApprovalHours";
import { filterIsChecked } from "./lib";
import useApprovalHours from "./store/useApprovalHours";
import { ApprovalHoursProvider } from "./store";
import { _formatDate } from "../../libs/dateUtils";
import { ButtonGroupApproved } from "./components/ButtonGroupApproved";
import { FilterGroupApproved } from "./components/FilterGroupApproved";
import "./index.scss";

export default function ApprovalHours() {
  return (
    <ApprovalHoursProvider>
      <ApprovalHoursComponent />
    </ApprovalHoursProvider>
  );
}

function ApprovalHoursComponent() {
  const { listRender, modalStatus, setModalStatus, handleSaveApi } = useApprovalHours();

  function handleSubmitAutoComplete() {
    const formData = filterIsChecked(listRender);
    const data = formData?.map((item) => {
      const obj = {
        timeWorkId: item.id,
        timeApproved: item.timeApproved === "" ? null : item.timeApproved || item.timeWorked,
      };
      return obj;
    });
    handleSaveApi(data);
  }

  function handleSubmit() {
    const formData = filterIsChecked(listRender);
    const data = formData?.map((item) => {
      const obj = {
        timeWorkId: item.id,
        timeApproved: item.timeApproved === "" ? null : item.timeApproved,
      };
      return obj;
    });
    handleSaveApi(data);
  }

  return (
    <>
      <Toaster position="top-right" reverseOrder toastOptions={{ duration: 3500 }} />
      <div className="AppointmentContainer box-header">
        <ModalMessageApprovalHours
          text={`Existem registros com horas em branco, deseja salvar assim ou preencher automático e salvar?`}
          status={modalStatus}
          onClickCancel={setModalStatus}
          onClickConfirm={handleSubmit}
          onClickPreenchiConfirm={handleSubmitAutoComplete}
        />
        <ButtonGroupApproved />
        <FilterGroupApproved />
        <TableComponent details={true} checkboxSelection={true} />
      </div>
    </>
  );
}
